import { z } from 'zod'

import { KonsoleUser } from 'app/types/users/konsole'

/** Payload to send when the user wants to login. */
export const LoginPayload = KonsoleUser.pick({
    username: true,
}).extend({
    password: z.string().min(1),
})

export type LoginPayload = z.infer<typeof LoginPayload>

/** Payload to send when the user wants to reset its password. */
export const AskResetPasswordPayload = KonsoleUser.pick({
    email: true,
})

export type AskResetPasswordPayload = z.infer<typeof AskResetPasswordPayload>

/** Auth tokens. */
export const AuthTokens = z.object({
    /** Access token. */
    access: z.string().min(1),

    /** Refresh token to get a new a new access token. */
    refresh: z.string().min(1),
})

export type AuthTokens = z.infer<typeof AuthTokens>
